import { InventoryCategory } from "@onmo/graphql/graphql";

export enum ShopTab {
  All = "shop_All",
  Owned = "shop_Owned",
  Bundles = "shop_Bundles",
  Avatars = "shop_Avatars",
}

export const LIST_TAB_SHOP = [
  ShopTab.All,
  ShopTab.Owned,
  ShopTab.Bundles,
  ShopTab.Avatars,
];

export const INVENTORIES_CATEGORY = [InventoryCategory.Avatar];

export const INVENTORIES_ORDER = ["Free", "Paid", "Premium"];
